import React from 'react';
import {Link} from "react-router-dom";
import {FiChevronDown} from "react-icons/fi";

const Nav = () => {
    return (
        <ul className="mainmenu">
            <li className="has-droupdown"><Link to="#">Web <FiChevronDown/></Link>
                <ul className="submenu">
                    <li><Link to="/web/web-design">Web Design</Link></li>
                    <li><Link to="/web/web-app-development">Web App Development</Link></li>
                </ul>
            </li>
            <li className="has-droupdown"><Link to="#">Mobile <FiChevronDown/></Link>
                <ul className="submenu">
                    <li><Link to="/mobile/android-apps">ANDROID Apps</Link></li>
                    <li><Link to="/mobile/ios-apps">IOS Apps</Link></li>
                    <li><Link to="/mobile/ussd">USSD</Link></li>
                </ul>
            </li>
            <li className="has-droupdown"><Link to="#">Marketing <FiChevronDown/></Link>
                <ul className="submenu">
                    <li><Link to="/marketing/search-engine-optimization">SEO</Link></li>
                    <li><Link to="/marketing/digital-marketing">Digital Marketing</Link></li>
                    <li><Link to="/marketing/bulk-sms">Bulk SMS</Link></li>
                </ul>
            </li>
            <li className="has-droupdown"><Link to="#">Business <FiChevronDown/></Link>
                <ul className="submenu">
                    <li><Link to="/business/cms-development">CMS Development</Link></li>
                    <li><Link to="/business/ecommerce">E-Commerce Development</Link></li>
                    <li><Link to="/business/payment-integration">Payments Integrations - API</Link></li>
                </ul>
            </li>
            <li className="has-droupdown"><Link to="/contact-us">Contact Us</Link></li>
        </ul>
    )
}
export default Nav;
